import designSystem from "@zoovu/design-system/src";

export default {
  ...designSystem()
};
